import { Component, OnInit } from '@angular/core';

import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'app-edit-meta-tag',
  templateUrl: './edit-meta-tag.component.html',
  styleUrls: ['./edit-meta-tag.component.css']
})
export class EditMetaTagComponent implements OnInit {
  Description;
  Keywords;
  constructor(private af: AngularFireDatabase, private firebaseApp: FirebaseApp) { }
  ngOnInit() {
    let snap = this.af.list('MetaTag');
    snap.subscribe((snapitem) => {
        this.Description = snapitem[0].description;
        this.Keywords = snapitem[0].keywords;
    })
  }

  UpDateitem(){
    let itemTmp;
    let Data = {
      description : this.Description,
      keywords : this.Keywords,
    }
    let updateData = this.af.list('/MetaTag')
    updateData.subscribe((snap) => {
        itemTmp = snap
        console.log(itemTmp)
        this.af.object('/MetaTag/'+snap[0].$key).update(Data).then((success)=>{
          alert("แก้ไขเสร็จสิ้น")
          window.location.reload();
        })
        //this.af.object('/MetaTag' + snap[0].$key).update({description:this.Description,keywords:this.Keywords});
        // updateData.update(itemTmp,{description:this.Description,keywords:this.Keywords,$key:"description"},).then((success) => {
        //   alert("แก้ไขเสร็จสิ้น")
        // })
    })
    
    
    
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/edit-meta-tag/edit-meta-tag.component.ts